import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { PermissionStatusCode } from '@app/municipality-management/models/externe-apps';
import { MunicipalityManagementConfigurationStore } from '@app/municipality-management/services/municipality-management-configuration.store';
import { MunicipalityManagementQueueStateService, PermissionType } from '@app/municipality-management/services/municipality-management-queue-state.service';
import { FeaturePermission, Permission } from '@app/shared/services/api/permission.service';
@Component({
  selector: 'app-basic-features-activation-tab',
  templateUrl: './basic-features-activation-tab.component.html',
  styleUrls: ['./basic-features-activation-tab.component.scss'],
})
export class BasicFeaturesActivationTabComponent {
  basicFeatures$: Observable<Permission[]>;
  isMunicipalityActive$ = this._configStore.isMunicipalityActive$;

  constructor(private _configStore: MunicipalityManagementConfigurationStore, private _queueStateService: MunicipalityManagementQueueStateService) {
    this.basicFeatures$ = this._configStore.municipalityBasicFeaturesConfig$.pipe(
      map((features) => this.buildPermissionTree(features)),
      distinctUntilChanged()
    );
  }

  public toggleFeature(isChecked: boolean, featureId: string): void {
    const allFeatures = this._configStore.municipalityFeaturesConfig;
    const clickedFeature = allFeatures.find((f) => f.guid === featureId);

    if (!clickedFeature) return;

    this.updateStandaloneFeature(clickedFeature, !isChecked);

    if (clickedFeature.parentPermissionID) {
      this.updateParentRestriction(allFeatures, clickedFeature.parentPermissionID);
    }

    this._configStore.setFeaturesConfig(allFeatures);
  }

  public trackByFn(feature: Permission): string {
    return feature.guid;
  }

  private buildPermissionTree(features: Permission[]): Permission[] {
    const parentFeatures = features.filter((feature) => !feature.parentPermissionID);
    const childrenFeature = features.filter((feature) => feature.parentPermissionID);

    return parentFeatures.map((parent) => ({
      ...parent,
      childPermissions: childrenFeature.filter((child) => child.parentPermissionID === parent.guid),
    }));
  }

  private updateStandaloneFeature(feature: Permission, isRestricted: boolean): void {
    const statusCode = isRestricted ? PermissionStatusCode.DEACTIVATEDBYMUNICIPALITY : PermissionStatusCode.ACTIVATEDBYMUNICIPALITY;

    this._queueStateService.addStatustoQueue(statusCode, feature as FeaturePermission, PermissionType.BASIC);
    feature.isRestricted = isRestricted;
  }

  private updateParentRestriction(allFeatures: Permission[], parentId: string): void {
    const parent = allFeatures.find((f) => f.guid === parentId);
    const children = allFeatures.filter((f) => f.parentPermissionID === parentId);

    if (parent && children.length > 0) {
      const shouldParentBeRestricted = children.every((child) => child.isRestricted);

      if (parent.isRestricted !== shouldParentBeRestricted) {
        this.updateStandaloneFeature(parent, shouldParentBeRestricted);
      }
    }
  }
}
